import {LanguageModel} from '../../translation/translation.models';
import {ServiceSubject} from './ServiceSubject';
import {SolutionStep} from './SolutionStep';

export class Solution {
  public id: number;
  public name?: string;
  public language?: number | LanguageModel;
  public serviceSubjects?: ServiceSubject[];
  public status: boolean;
  public deletedAt: any;
  public position: number;
  public solutionSteps: Array<SolutionStep> = [];
}
